// Endpoint do wysyłki formularza kontaktowego / "Zapytaj o pobyt".
// Produkcja (LH.pl, strona statyczna): ustaw REACT_APP_CONTACT_ENDPOINT
//   na https://przystanwciszy.pl/contact.php przed `yarn build`.
// Podgląd / Emergent: bez tej zmiennej używany jest backend FastAPI (/api/contact).
export const CONTACT_ENDPOINT =
  process.env.REACT_APP_CONTACT_ENDPOINT ||
  `${process.env.REACT_APP_BACKEND_URL || ""}/api/contact`;
